import { Mark } from "tiptap"
import { toggleMark } from "tiptap-commands"

export default class TextColor extends Mark {
  get name() {
    return "textcolor"
  }

  get defaultOptions() {
    return {
      color: ["red"]
    }
  }

  get schema() {
    return {
      attrs: {
        color: {
          default: "#dfc79b"
        }
      },
      parseDOM: [
        {
          style: "color",
          getAttrs: mark => ({ color: mark })
        }
      ],
      toDOM: node => {
        return [
          "span",
          {
            style: `color: ${node.attrs.color}`
          },
          0
        ]
      }
    }
  }

  commands({ type }) {
    return attrs => toggleMark(type, attrs)
  }
}
